import React, { useEffect, useState } from "react";
import { initForm, validate, getIsDisabled } from "./formUtility";
import { WrapperComponent } from "./WrapperComponent";
import { TransTextInput } from "./TransTextInput";
import { TransButton } from "../TransButton";
import TransDatePicker from "./TransDateField";
import _, { forEach } from "lodash";
import { Formik, Form as FormikForm } from "formik";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import TransFileUpload from "./TransFileUpload";
import TransTextView from "./TransTextView";
import TransIconButton from "./TransIconButton";
import { PnpSelect, pnpSelect } from "./PnpSelect";
import { MenuSelect } from "./MenuSelect";
import CurrencyInput from "./CurrencyInput";
import { PnpTextArea } from "./PnpTextArea";
import SelectWithInput from "./SelectWithInput";
import { EnergySavingsLeafOutlined } from "@mui/icons-material";
import { element } from "prop-types";
import { TransSelect } from "./TransSelect";
// Import the new role component
import TransRoleDropdown from "./TransRoleDropdown";
import TransDateTimePicker from "./TransDateTimePicker";

export const TransForm = React.memo(
  ({
    submitAction,
    cancelAction,
    btnClick,
    formInputs,
    data,
    mode,
    passFormData,
    isUpdateFormData = true,
    onDeleteClick,
    cardlength,
    getFormData,
    // Role management handlers
    onRoleCreate,
    onRoleEdit,
    onRoleDelete,
    //formErrors
  }) => {
    const [formConfigInputs, setFormConfigInputs] = useState([]);
    const [formData, setFormData] = useState({});
    const [validationSchemaState, setValidationSchemaState] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();
    
    // ...existing code...
const sanitizeDeadlineValue = (values) => {
  const fields = ["dead_line_voting", "deadline_voting"];
  const sanitized = { ...values };
  fields.forEach((field) => {
    if (sanitized[field] === 0 || sanitized[field] === "0") {
      sanitized[field] = "";
    }
  });
  return sanitized;
};
    
useEffect(() => {
  const { values, validationSchema } = initForm(formInputs);
  setFormConfigInputs(formInputs);

  const initialData = _.isEmpty(data)
    ? values
    : sanitizeDeadlineValue(data);

  if (isUpdateFormData || _.isEmpty(formData)) {
    setFormData(initialData);
  }

  setValidationSchemaState(validationSchema);
}, [data, formInputs, isUpdateFormData]);
    
    // useEffect(() => {
    //   const { values, validationSchema } = initForm(formInputs);
    //   setFormConfigInputs(formInputs);

    //   if (_.isEmpty(data)) {
    //     if (isUpdateFormData || _.isEmpty(formData)) {
    //       setFormData(values);
    //     }
    //   } else {
    //     if (isUpdateFormData || _.isEmpty(formData)) {
    //       setFormData(data);
    //     }
    //   }

    //   setValidationSchemaState(validationSchema);
    // }, [data, formInputs, isUpdateFormData]);

    const onCancel = () => {
      if (cancelAction) {
        cancelAction();
      } else {
        navigate(-1);
      }
    };

    const [disablebtn, setDisableBtn] = useState(true);

    const onSubmit = async (name) => {
      try {
        setIsSubmitting(true);
        const validatedData = await validate(validationSchemaState, formData);
        if (validatedData) {
          submitAction(formData, name);
        }
      } catch (err) {
        updateErrorMessage(err);
      }
      setIsSubmitting(false);
    };

    const onBtnClick = async () => {
      if (btnClick) {
        btnClick(formData);
      }
    };

    const ClickActions = {
      action: onSubmit,
      cancel: onCancel,
      button: onBtnClick,
    };

    // Updated FormObject to include role component
    const FormObject = {
      text: TransTextInput,
      password: TransTextInput,
      action: TransButton,
      SelectWithInput: SelectWithInput,
      button: TransButton,
      cancel: TransButton,
      wrapper: WrapperComponent,
      select: PnpSelect,
      file: TransFileUpload,
      files: TransFileUpload,
      date: TransDatePicker,
      textview: TransTextView,
      number: TransTextInput,
      iconbutton: TransIconButton,
      currencyinput: CurrencyInput,
      textArea: PnpTextArea,
      menuselect: MenuSelect,
      transSelect: TransSelect,
      // Add role component
      role: TransRoleDropdown,
       // Add this line for datetime picker
      datetime: TransDateTimePicker

    };

      const clearFieldErrors = (fields, targetNames) => {
      return fields.map((field) => {
        if (field.children) {
          field = {
            ...field,
            children: clearFieldErrors(field.children, targetNames),
          };
        }
        if (targetNames.includes(field.name)) {
          const { errors, ...rest } = field;
          return rest;
        }
        return field;
      });
    };

    const removeDeadlineErrors = () => {
      setFormConfigInputs((prev) =>
        clearFieldErrors(prev, ["dead_line_voting", "deadline_voting"])
      );
    };

    const onChange = async (key, value) => {
      const newFormData = { ...formData, [key]: value };
      // Clear field-specific errors when user starts typing
        // if (formErrors && formErrors[key]) {
        //   const newErrors = { ...formErrors };
        //   delete newErrors[key];
        //   // You'll need to pass a setFormErrors prop or similar to update parent state
        //   // This part depends on how you want to handle the error clearing
        // }
      passFormData && passFormData(newFormData, key, value);
      setFormData(newFormData);
      if (getFormData) {
        getFormData(newFormData);
      }

      const validatedData = await validate(validationSchemaState, newFormData);
      if (validatedData) {
         removeDeadlineErrors();
        setDisableBtn(false);
      } else {
        setDisableBtn(true);
      }
    };

    const generateForm = (element, key = false) => {
      const { 
        shape, 
        name, 
        type, 
        options, 
        show, 
        customeonchange, 
        isDisabled, 
        submitButton,
        fileRestriction, 
        ...rest 
      } = element;
      
      const FormElement = FormObject[element.type] || TransTextInput;
      const props = {
        ...rest,
        name,
        ...(type === "wrapper" && { FormObject, generateForm }),
        onClick: ClickActions[element.type],
        type: type === "confirmPassword" ? "password" : type,
        onChange: onChange,
        customeonchange: customeonchange,
        onDeleteClick: onDeleteClick,
        isDisabled: submitButton ? (disablebtn ? true : false) : isDisabled,
        cardlength: cardlength,
        isSubmitting,
        options: options,
        fileRestriction: fileRestriction ? fileRestriction : null,
        value: type == 'date' && formData[name] == '' ? null : formData[name],
        countryCode: 'pot_currency' in formData ? formData['pot_currency'] : 'USD',
        mode,
        formData,
        // Add role management handlers for role component
        ...(type === 'role' && {
          onRoleCreate: onRoleCreate,
          onRoleEdit: onRoleEdit,
          onRoleDelete: onRoleDelete
        }),
        ...(key && { keyValue: key }),
      };

      return show == false ? '' : <FormElement {...props} />;
    };

    const updateErrorMessage = (err) => {
      const inner = err?.inner;
      let errorFields = _.uniq(inner?.map((inn) => inn.path)) || [];

      let newFormInputs = getErrorMessage(formInputs, inner, errorFields);
      setFormConfigInputs(newFormInputs);
    };

    const getErrorMessage = (fields, inner, errorFields) => {
      return fields.map((field) => {
        if (field.children) {
          field.children = getErrorMessage(field.children, inner, errorFields);
        }
        if (errorFields.includes(field.name)) {
          field.errors = {
            status: true,
            message: inner.find((inn) => field.name === inn.path).errors[0],
          };
        }
        return field;
      });
    };

    return (
      <Formik sx={{ py: 10 }} enableReinitialize initialValues={data || formData}>
        <FormikForm noValidate>
          {formConfigInputs &&
            formConfigInputs.map((element, index) => {
              return (
                <Box key={index} sx={{ mt: 2, px: 6 }}>
                  {element && generateForm(element)}
                </Box>
              );
            })}
        </FormikForm>
      </Formik>
    );
  }
);